import * as React from "react";
import { TextField, Autocomplete, Alert, Box } from "@mui/material";
import { useGetRaterTypesByInstrumentKeyQuery } from "../../../../services/cclTokenedEnterpriseRaterApi";
import ComponentLoader from "../../../../components/common/componentLoader";
import CclDrawer from "../../../../components/common/cclDrawer/cclDrawer";
import CclDrawerActionBar from "../../../../components/common/cclDrawer/cclDrawerActionBar";
import CclButton from "../../../../components/common/cclButtons/cclButton";
import CclLoadingButton from "../../../../components/common/cclButtons/cclLoadingButton";
import { ParticipantRaterDetail } from "../../../../services/types/enterpriseParticipantApiTypes";

export type EditRaterTypesDrawerProps = {
    open: boolean;
    raterDetail: ParticipantRaterDetail | null;
    onOk: (rMKey: number, raterTypeId: number) => Promise<void>;
    onCancel: () => void;
};

const EditRaterTypesDrawer: React.FC<EditRaterTypesDrawerProps> = (props) => {
    const [selectedRaterType, setSelectedRaterType] = React.useState<string>("");
    const [saving, setSaving] = React.useState<boolean>(false);
    const { data: raterTypeList, isLoading } = useGetRaterTypesByInstrumentKeyQuery(
        props.raterDetail?.instrumentKey ?? 0,
        { skip: props.raterDetail?.instrumentKey === null },
    );

    const handleOk = async () => {
        if (props.raterDetail?.rmKey != null) {
            setSaving(true);
            try {
                await props.onOk(
                    props?.raterDetail?.rmKey,
                    raterTypeList
                        ? raterTypeList?.filter((r) => r.name === selectedRaterType)[0].raterTypeId
                        : 0,
                );
            } finally {
                setSaving(false);
            }
        }
    };

    return (
        <CclDrawer
            title={"Edit Rater"}
            open={props.open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            onClose={props.onCancel}
        >
            {isLoading ? (
                <ComponentLoader msg="Loading" />
            ) : (
                <>
                    <Box>
                        <Autocomplete
                            id="tags-standard"
                            options={
                                raterTypeList
                                    ?.filter((r) => r.name !== props.raterDetail?.raterTypeName)
                                    .map((option) => option.name) ?? []
                            }
                            value={selectedRaterType}
                            onChange={(e: any, newValue: string | null) => {
                                setSelectedRaterType(newValue ?? "");
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="standard"
                                    placeholder="Rater Types"
                                    label="Rater Types"
                                    sx={{ mt: 2, mb: 2 }}
                                />
                            )}
                        />
                        {(selectedRaterType === "Boss" ||
                            selectedRaterType === "Other" ||
                            selectedRaterType === "Superior") && (
                            <Alert severity="warning">
                                You are switching this rater to a non-Confidential Type. Please
                                notify the rater if necessary.
                            </Alert>
                        )}
                    </Box>

                    <CclDrawerActionBar>
                        <CclLoadingButton
                            id="ok-btn"
                            disabled={selectedRaterType === "" || selectedRaterType === null}
                            onClick={handleOk}
                            mode={"primary"}
                            loading={saving}
                        >
                            Save
                        </CclLoadingButton>
                        <CclButton
                            id="cancel-btn"
                            onClick={() => props.onCancel()}
                            mode={"secondary"}
                        >
                            Cancel
                        </CclButton>
                    </CclDrawerActionBar>
                </>
            )}
        </CclDrawer>
    );
};
export default EditRaterTypesDrawer;
